export default {
  container: {
    position: 'fixed',
    bottom: '40px',
    left: '10%',
    right: '10%',
    width: '80%',
    padding: '20px 14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '5px',
    boxShadow: '0 0 2px 1px rgba(0, 0, 0, 0.2)',
    backgroundColor: 'rgba(46, 49, 49, 1)',
    color: '#fff',
    opacity: '0.9',
    fontSize: '16px',
    zIndex: '999',

    '@media screen and (max-width: 600px)': {
      left: 0,
      right: 0,
      bottom: 0,
      width: '100%',
      borderRadius: 0,
      flexDirection: 'column',
      alignItems: 'stretch',
      padding: '10px 16px 12px',
      gap: '8px',
      fontSize: '14px',
      lineHeight: 1.35,

      '& p': {
        margin: 0,
      },
    },
  },
  close: {
    backgroundColor: '#777',
    border: 'solid 1px',
    color: '#fff',
    borderRadius: '2px',
    cursor: 'pointer',
    padding: '5px 10px',
    fontSize: '16px',

    '@media screen and (max-width: 600px)': {
      minHeight: '44px',
      width: '100%',
    },
  },
  link: {
    color: '#fff',
  },
  fadeAway: {
    opacity: 0,
    pointerEvents: 'none',
    transition: 'all 250ms linear',
  },
  hide: {
    display: 'none',
  },
};
